import { Button, SpeedDial, SpeedDialAction, Typography } from '@mui/material';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import _ from 'lodash';
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DialogsContext, SessionDataContext } from '../contexts';
import { holidayApi } from '../holiday/holiday.queries';
import { userApi } from '../user/user.queries';
import { useAuth } from '../auth/auth.provider';

export const useDateParam = () => {
	let date = new URLSearchParams(useLocation().search).get('date');
	date = date ? parseInt(date) : new Date().getTime();
	return date;
};

export const useCalendar = (unit, getFirstDayOfUnit, getLastDayOfUnit, filters) => {
	const { can } = useAuth();
	const useGetAll = holidayApi.useGetAll();
	const holidays = useGetAll?.data;

	const sessionData = useContext(SessionDataContext);
	const dateParam = useDateParam();
	const { dialogs } = useContext(DialogsContext);
	const [startDate, setStartDate] = useState(getFirstDayOfUnit(dateParam));
	const [endDate, setEndDate] = useState(getLastDayOfUnit(startDate));
	
	const from = startDate.startOf('day').valueOf();
	const to = endDate.endOf('day').valueOf();
	const useCalendar = userApi.useCalendar(from, to);
	const activities = useCalendar?.data;

	const filterActivities = (activities) => {
		let filteredActivities = activities;
		if( filters?.length ){
			_.forEach(filters, filter => {
				filteredActivities = _.filter(filteredActivities, filter);
			});
		}
		else{
			if (sessionData.filterStudentIds?.length) {
				filteredActivities = _.filter(filteredActivities, activity => _.indexOf(sessionData.filterStudentIds, activity.enrollment?.student?.id) >= 0);
			}
			if (sessionData.filterSubjectIds?.length) {
				filteredActivities = _.filter(filteredActivities, activity => _.indexOf(sessionData.filterSubjectIds, activity.courseDetail?.course?.subject?.id) >= 0);
			}
			if (sessionData.filterCourseIds?.length) {
				filteredActivities = _.filter(filteredActivities, activity => _.indexOf(sessionData.filterCourseIds, activity.courseDetail?.course?.id) >= 0);
			}
			if (sessionData.filterStatuses?.length) {
				filteredActivities = _.filter(filteredActivities, activity => _.indexOf(sessionData.filterStatuses, activity.status) >= 0);
			}
		}
		return filteredActivities;
	}

	const moveCalendar = (delta, skipHistory, adjustHistory) => {
		let newStartDate = moment(startDate.add(delta, unit));
		setCalendar(newStartDate, skipHistory, adjustHistory);
	};

	const setCalendar = (newStartDate, skipHistory, adjustHistory) => {
		window.scrollTo(0, 0);//Scroll to top to prevent floating header issue
		let newEndDate = getLastDayOfUnit(newStartDate);
		if (!skipHistory) {
			window.history.pushState({}, "", '?date=' + (adjustHistory ? adjustHistory(newStartDate) : newStartDate));
		}
		setStartDate(newStartDate);
		setEndDate(newEndDate);
	};

	const getHoliday = (refMoment) => {
		for (let i = 0; i < holidays?.length; i++) {
			let holiday = holidays[i];
			let result = refMoment.isSame(moment(holiday.startDate), 'day');
			result = result || (holiday.endDate != null && refMoment.isSame(moment(holiday.endDate), 'day'));
			result = result || (holiday.endDate != null && refMoment.isBetween(moment(holiday.startDate), moment(holiday.endDate)));
			if (result) {
				return holiday;
			}
		}
		return null;
	};

	const isHoliday = (refMoment) => {
		return getHoliday(refMoment) != null;
	};

	const todayButton = (
		<Button variant="text" onClick={() => { setCalendar(getFirstDayOfUnit(new Date())) }}>Today</Button>
	);

	const fabControl = can('holiday.create') && (
		<React.Fragment>
			<SpeedDial sx={{ position: 'fixed', bottom: 10, right: (sessionData.drawerOpen ? 350 : 40), alignItems: 'end', '.MuiSpeedDial-actions': { alignItems: 'end', '.MuiFab-circular': { borderRadius: 2, width: 'auto' } } }} color="primary" icon={<SpeedDialIcon />} ariaLabel="">
				<SpeedDialAction icon={<Typography sx={{ p: 2 }}>Add Break</Typography>} onClick={() => dialogs.open('holiday', { startDate: startDate, endDate: endDate })} />
			</SpeedDial>
		</React.Fragment>
	);

	const filteredActivities = filterActivities(activities);

	return { filteredActivities, moveCalendar, setCalendar, startDate, endDate, getHoliday, isHoliday, todayButton, fabControl };
};
